import { render, staticRenderFns } from "./ListPrestacoesConta.vue?vue&type=template&id=4a922764&"
import script from "./ListPrestacoesConta.vue?vue&type=script&lang=js&"
export * from "./ListPrestacoesConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports